module.exports = __webpack_public_path__ + "img/icons8-kia.3e22d666.svg";